<template>
    <div
        class="ellipsis-container"
        :style="{ maxWidth: maxWidth ? `${maxWidth}px` : `100%` }">
        <component
            :is="elementTag"
            ref="content"
            v-pendo-tooltip="getTooltipConfig"
            class="ellipsis-content"
            :href="href"
            target="_blank"
            @mouseover="checkOverflow">
            {{ text }}
        </component>
    </div>
</template>

<script>
import { PendoTooltip } from '@pendo/components';

export default {
    directives: {
        PendoTooltip,
    },
    props: {
        maxWidth: {
            type: Number,
            default: undefined,
        },
        text: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            default: 'text',
            validator: (type) => ['link', 'text'].includes(type),
        },
        href: {
            type: String,
            default: undefined,
        },
        tooltipConfig: {
            type: Object,
            default: () => ({}),
        },
    },
    data () {
        return {
            showTooltip: false,
        };
    },
    computed: {
        elementTag () {
            if (this.type === 'link') {
                return 'a';
            }

            return 'div';
        },
        getTooltipConfig () {
            return { ...this.tooltipConfig, content: this.showTooltip ? this.text : '' };
        },
    },
    methods: {
        checkOverflow () {
            const { content } = this.$refs;
            this.showTooltip = content.offsetWidth < content.scrollWidth;
        },
    },
};
</script>

<style scoped lang="less">
.ellipsis-container {
    .ellipsis-content {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
    }
}
</style>
